import { Formatter } from "@shared/utils/formatter";

export const $f = new Formatter();

export function useFormatter() {
  return $f;
}
